import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { minTablet, minDesktop, mediaPhone } from '../styles/breakpoints';
import { SecondaryTextColor } from '../styles/colors';
import { PHONE_MARGIN, TABLET_MARGIN } from '../styles/pageLayout';

import H2 from '../H2';

import ExternalLinksSection from './ExternalLinksSection';
import ExternalLinksShape from './ExternalLinksShape';

const Container = styled.div`
  margin-left: ${-PHONE_MARGIN}px;
  margin-right: ${-PHONE_MARGIN}px;

  ${minTablet} {
    margin-left: ${-TABLET_MARGIN + 40}px;
    margin-right: ${-TABLET_MARGIN + 40}px;
  }
  ${minDesktop} {
    margin-left: 80px;
    margin-right: 80px;
  }
`;

const SectionsList = styled.ul`
  margin-top: 13px;
  padding: 0;
`;

const ExternalLinksSectionStyled = styled(ExternalLinksSection)`
  border-bottom: ${({ collapsable, sources }) => (collapsable && sources.length > 1 ? `1px solid ${SecondaryTextColor}` : 0)};

  &:last-child {
    ${minDesktop} {
      border-bottom: 0;
    }
  }
`;

const Headline = styled(H2)`
  ${mediaPhone} {
    margin-left: 25px;
    margin-right: 25px;
    margin-bottom: 20px;
  }
  ${minTablet} {
    margin-bottom: 40px;
  }
  ${minDesktop} {
    margin-bottom: 50px;
  }
`;

const ExternalLinksCollection = ({
  headline,
  sources,
  showIds,
  collapsable,
}) => (
  <Container>
    <Headline>
      { headline }
    </Headline>
    <SectionsList>
      { sources.map(({
        id,
        title,
        items,
        download,
      }) => (
        <ExternalLinksSectionStyled
          key={id || title}
          id={id}
          headline={title}
          showId={showIds}
          sources={items}
          collapsable={collapsable}
          download={download}
        />
      ))}
    </SectionsList>
  </Container>
);

ExternalLinksCollection.propTypes = {
  headline: PropTypes.string,
  sources: ExternalLinksShape.isRequired,
  showIds: PropTypes.bool,
  collapsable: PropTypes.bool,
};

ExternalLinksCollection.defaultProps = {
  headline: '',
  showIds: false,
  collapsable: false,
};

export default ExternalLinksCollection;



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalLinksCollection.js